module.exports = __webpack_public_path__ + "static/media/torah.ab253bb8.svg";